module.exports = __webpack_public_path__ + "static/media/gal-4.c6fff3a1.jpeg";